
import { Component, Prop, Vue } from 'vue-property-decorator';
import SvgReload from '@/assets/icons/reload.svg';
import SvgTrash from '@/assets/icons/trash.svg';
@Component({
    components: { SvgReload, SvgTrash },
})

export default class TrashBtn extends Vue {
    @Prop({ default: true }) readonly isIcon!: boolean;
    @Prop({ default: '' }) readonly title!: string;
    @Prop({ default: true }) readonly isBorderless!: boolean;
    @Prop({ default: false }) readonly isGrey!: boolean;
    @Prop({ default: false }) readonly isMobile!: boolean;
    @Prop({ default: false }) readonly isReloadIcon!: boolean;
}
